/**
 * SDKEvents
 * @type {Array}
 */
const SDKEvents = [
  'SDK_READY',
  'SDK_ERROR',
  'SDK_LB_LOGIN',
  'SDK_SHW_LB',
  'SDK_GAME_START',
  'SDK_GAME_PAUSE',
  'SDK_GDPR_TRACKING',
  'SDK_GDPR_TARGETING',
  'SDK_GDPR_THIRD_PARTY',
  'AD_SDK_MANAGER_READY',
  'AD_SDK_CANCELED',
  'AD_IS_ALREADY_RUNNING',
  'SDK_REWARDED_WATCH_COMPLETE',
];

/**
 * IMAEvents
 * @type {Array}
 */
const IMAEvents = [
  'AD_ERROR',
  'AD_BREAK_READY',
  'AD_METADATA',
  'ALL_ADS_COMPLETED',
  'CLICK',
  'COMPLETE',
  'CONTENT_PAUSE_REQUESTED',
  'CONTENT_RESUME_REQUESTED',
  'DURATION_CHANGE',
  'FIRST_QUARTILE',
  'IMPRESSION',
  'INTERACTION',
  'LINEAR_CHANGED',
  'LOADED',
  'LOG',
  'MIDPOINT',
  'PAUSED',
  'RESUMED',
  'SKIPPABLE_STATE_CHANGED',
  'SKIPPED',
  'STARTED',
  'THIRD_QUARTILE',
  'USER_CLOSE',
  'VOLUME_CHANGED',
  'VOLUME_MUTED',
  'DISPLAYAD_IMPRESSION',
  'DISPLAYAD_ERROR',
];

export { SDKEvents, IMAEvents };
